import { CnRangeTimePickerPro as UiCnRangeTimePickerPro } from "../../components/cn-time-picker-pro";
import { connect, mapProps } from '@formily/react';
import { mapSize, mapStatus } from '../__builtins__';
export var CnRangeTimePickerPro = connect(UiCnRangeTimePickerPro, mapProps(mapSize, mapStatus));
